'use client';

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyD4g2SCCF1AQnYfgCdbwHhPvfAuLlTl6kA',
  authDomain: 'studio-3586002482-732bd.firebaseapp.com',
  projectId: 'studio-3586002482-732bd',
  storageBucket: 'studio-3586002482-732bd.firebasestorage.app',
  messagingSenderId: '82600561753',
  appId: '1:82600561753:web:c076199ed635aa115c3548',
  measurementId: 'G-XXXXXXXXXX',
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
